// src/components/ContactForm.js
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import emailjs from 'emailjs-com';

const EMAILJS_SERVICE  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const EMAILJS_TEMPLATE = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE;
const EMAILJS_USER     = process.env.REACT_APP_EMAILJS_USER_ID;

const ContactForm = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [message, setMessage]   = useState('');
  const [isError, setIsError]   = useState(false);
  const [sending, setSending]   = useState(false);

  const onSubmit = (data) => {
    setSending(true);
    emailjs
      .send(EMAILJS_SERVICE, EMAILJS_TEMPLATE, data, EMAILJS_USER)
      .then(() => {
        setMessage('Thank you for reaching out! We will get back to you soon.');
        setIsError(false);
        reset();
      })
      .catch(() => {
        setMessage('There was an issue sending your message. Please try again later.');
        setIsError(true);
      })
      .finally(() => setSending(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="contact-form" noValidate>
      <div className="form-group">
        <label htmlFor="cf-name">Name *</label>
        <input
          id="cf-name"
          type="text"
          placeholder="Your name"
          className={errors.name ? 'input-error' : ''}
          {...register('name', { required: 'Please enter your name' })}
        />
        {errors.name && <span className="error-message">{errors.name.message}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="cf-email">Email *</label>
        <input
          id="cf-email"
          type="email"
          placeholder="you@email.com"
          className={errors.email ? 'input-error' : ''}
          {...register('email', {
            required: 'Email is required',
            pattern: { value: /^\S+@\S+\.\S+$/, message: 'Invalid email address' }
          })}
        />
        {errors.email && <span className="error-message">{errors.email.message}</span>}
      </div>

      <div className="form-group">
        <label htmlFor="cf-message">Message *</label>
        <textarea
          id="cf-message"
          placeholder="How can we help you?"
          className={errors.message ? 'input-error' : ''}
          {...register('message', { required: 'Please enter a message' })}
        />
        {errors.message && <span className="error-message">{errors.message.message}</span>}
      </div>

      <button type="submit" className="submit-button" disabled={sending}>
        {sending ? 'Sending…' : 'Send Message'}
      </button>

      {message && (
        <div className={isError ? 'error-message-container' : 'success-message-container'}>
          {message}
        </div>
      )}
    </form>
  );
};

export default ContactForm;
